module.exports = __webpack_public_path__ + "img/buy-button.e82636b4.svg";